/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '项目参与人',
    tip: '项目参与人',
    key: 'fullName',
    id: 'fullName',
    slot: 'input'
  },
  {
    width: 180,
    label: '手机号',
    tip: '手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input'
  },
  {
    width: 180,
    label: '结算状态',
    tip: '请选择结算状态',
    key: 'settlementStatus',
    id: 'settlementStatus',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '未结算',
        key: 0
      },
      {
        name: '结算中',
        key: 1
      },
      {
        name: '已结算',
        key: 2
      }
    ]
  }
];
